import { render, staticRenderFns } from "./laporan_ringkas_pelengkap_data.vue?vue&type=template&id=54a9e622&"
import script from "./laporan_ringkas_pelengkap_data.vue?vue&type=script&lang=js&"
export * from "./laporan_ringkas_pelengkap_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports